import { render, staticRenderFns } from "./setpRule.vue?vue&type=template&id=7b3cfdae&scoped=true"
import script from "./setpRule.vue?vue&type=script&lang=js"
export * from "./setpRule.vue?vue&type=script&lang=js"
import style0 from "./setpRule.vue?vue&type=style&index=0&id=7b3cfdae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3cfdae",
  null
  
)

export default component.exports